import { render, staticRenderFns } from "./ChannelTypesEdit.vue?vue&type=template&id=47587c15&"
import script from "./ChannelTypesEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelTypesEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelTypesEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelTypesEdit.vue"
export default component.exports